import actionTypes from '../../action-types'

export default (payload, included) => ({
  type: actionTypes.USER.SET,
  payload,
  included,
})
